import { EqlFieldName } from '@modules/common/constants';
import { EqlField } from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';

export const getFieldNameFromEqlField = (eqlField: EqlField): FieldNames => {
  switch (eqlField.field) {
    case EqlFieldName.Entity:
      return FieldNames.Entity;
    case EqlFieldName.Reason:
      return FieldNames.Reason;
    case EqlFieldName.Source:
      return FieldNames.Source;
    case EqlFieldName.Language:
      return FieldNames.Language;
    case EqlFieldName.UserSentiment:
      return FieldNames.ReviewSentiment;
    case EqlFieldName.EntitySentiment:
      return FieldNames.EntitySentiment;
    case EqlFieldName.FeedbackRecords:
      return FieldNames.FeedbackRecords;
    case EqlFieldName.L1:
      return FieldNames.L1;
    case EqlFieldName.EntityCategory:
      return FieldNames.Entity;
    default:
      return FieldNames.Metadata;
  }
};
